import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExploreIconActive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.75 11.5C0.75 5.56294 5.56294 0.75 11.5 0.75C17.4371 0.75 22.25 5.56294 22.25 11.5C22.25 17.4371 17.4371 22.25 11.5 22.25C5.56294 22.25 0.75 17.4371 0.75 11.5ZM15.6172 8.44212C15.8904 7.84111 16.027 7.54061 15.9707 7.35888C15.9219 7.20143 15.7986 7.07815 15.6411 7.02934C15.4594 6.97301 15.1589 7.1096 14.5579 7.38278L11.8099 8.63187C11.0014 8.99938 10.5971 9.18314 10.2509 9.4419C9.9439 9.6714 9.6714 9.9439 9.4419 10.2509C9.18314 10.5971 8.99938 11.0014 8.63187 11.8099L7.38278 14.5579C7.1096 15.1589 6.97301 15.4594 7.02934 15.6411C7.07815 15.7986 7.20143 15.9219 7.35888 15.9707C7.54061 16.027 7.84111 15.8904 8.44211 15.6172L11.1901 14.3681C11.9986 14.0006 12.4029 13.8169 12.7491 13.5581C13.0561 13.3286 13.3286 13.0561 13.5581 12.7491C13.8169 12.4029 14.0006 11.9986 14.3681 11.1901L15.6172 8.44212Z",
		fill: "currentColor"
	})
});
export default SvgExploreIconActive;
